var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-layout',{staticClass:"fit",attrs:{"view":"hHh lpr fff"}},[_c('Header'),_c('q-page-container',{staticClass:"fit"},[_c('RoleGuard',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }